export default __webpack_public_path__ + "static/media/meal-medium.aae596fb.svg";